/* eslint-disable no-console */
import { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { lockTimerState } from 'store';
import { GameStatus } from '@/components/types';
import { GameTimer } from '../GameTimer';

export type GameTimerTranslations = {
  points: string;
  experienceTime: string;
  progressTrnslt: string;
};

export const TimerWrap = ({
  timerCondition,
  username,
  gamePoints,
  gameStatus,
  game,
  analytic,
  onEndExperience,
  gameTimeRef,
  hasClientLogo,
}: any) => {
  const [gameTime, setGameTime] = useState<number>(0);
  const [lockTimer, setLockTimer] = useRecoilState(lockTimerState);

  // 2nd level
  const initGameData = () => {
    const limitTime = game.limitTime * 60 * 1000;
    const currentGameTime = game.timerType === 'stopwatch' ? 1 : limitTime;
    setGameTime(currentGameTime);
  };

  const mainGameTimer = () => {
    if (
      gameStatus === GameStatus.SuccessfullyEndedWithoutFinalScreen ||
      gameStatus === GameStatus.NotStarted
    ) {
      return;
    }

    if (lockTimer?.running && lockTimer?.value) {
      // eslint-disable-next-line @typescript-eslint/no-shadow
      setLockTimer((lockTimer: any) => {
        if (lockTimer?.running && lockTimer?.value)
          return { running: lockTimer.running, value: lockTimer.value - 1 };
        return lockTimer;
      });
    }

    let currentGameTime = gameTime;
    if (game.timerType === 'stopwatch') currentGameTime += 1000;
    else currentGameTime -= 1000;

    analytic.setTime(
      game.timerType === 'stopwatch'
        ? currentGameTime
        : game.limitTime * 60 * 1000 - currentGameTime,
    );
    if (currentGameTime > 0 && (!game.limitTime || currentGameTime < game.limitTime * 60 * 1000)) {
      setGameTime(currentGameTime);
      gameTimeRef.current = currentGameTime;
    } else {
      // end experience setstate result screen
      onEndExperience();
    }
  };

  useEffect(() => {
    console.debug('--hook gameStatus 0');
    if (gameStatus === GameStatus.Started) {
      console.debug('--hook gameStatus 1');
      initGameData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameStatus]);

  useEffect(() => {
    const timerInterval = setTimeout(mainGameTimer, 1000);
    return function cleanup() {
      clearTimeout(timerInterval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameTime]);

  return (
    timerCondition &&
    (game.timerOn || game.progressOn) && (
      <GameTimer
        timerOn={game.timerOn}
        scoreType={game.scoreType}
        progressOn={game.progressOn}
        locks={game.locks}
        gameTime={gameTime}
        username={username}
        gamePoints={gamePoints}
        hasClientLogo={hasClientLogo}
      />
    )
  );
};
